export default {
  where: window.drupalSettings?.santeIframeConfig?.params?.ou,
  what: window.drupalSettings?.santeIframeConfig?.params?.quoi,
  what_back: window.drupalSettings?.santeIframeConfig?.params?.quoi_back,

  getPlaceholder() {
    let placeholder = 'Précisez votre ville';
    const route = new URLSearchParams(window.location.search);
    if (route.has('ou') || route.has('o')) {
      if (this.what_back) {
        placeholder = `${this.what_back.join(' ')}, `;
      } else if (this.what) {
        placeholder = `${this.what}, `;
      }
      placeholder += this.where;
    } else if (this.where !== '*' && this.what_back) {
      placeholder = `${this.what_back.join(' ')}, `;
      placeholder += this.where;
    }
    return placeholder;
  },
};
